import {
  Badge,
  GreenGreen80,
  GreyGrey20,
  GreyGrey30,
  GreyGrey70,
  GreyGrey90,
  IconCheckCircle,
  IconExclamationTriangle,
  Image,
  Primary13SemiBold,
  YellowYellow60,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { ResolvedIntegration } from 'modules/Integrations/domain'

export const IntegrationGroupListItem = (
  props: ResolvedIntegration & {
    onClick: () => void
    selected: boolean
  }
) => {
  return (
    <Grid
      data-testid={`integrationsBrowser.listItem.${props.id}`}
      padding="0 4px 0 8px"
      templateColumns="auto 1fr auto"
      height="32px"
      gap="8px"
      borderRadius="6px"
      alignContent="center"
      cursor="pointer"
      alignItems="center"
      backgroundColor={props.selected ? GreyGrey20 : 'transparent'}
      _hover={{
        backgroundColor: GreyGrey20
      }}
      userSelect="none"
      onClick={props.onClick}
    >
      <GridItem>
        {props.smallLogoUrl ? (
          <Image height="16px" width="16px" src={props.smallLogoUrl} />
        ) : (
          <IconExclamationTriangle color={YellowYellow60} />
        )}
      </GridItem>
      <GridItem
        {...Primary13SemiBold}
        color={props.selected ? GreyGrey90 : GreyGrey70}
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
      >
        {props.title}
      </GridItem>
      <GridItem display="flex" alignItems="center">
        {props.state === 'CONNECTED' && (
          <Badge
            data-testid={`integrationsBrowser.listItem.${props.id}.connected`}
            sentiment="success"
            containerStyle={
              props.selected ? { backgroundColor: GreyGrey30 } : {}
            }
          >
            <IconCheckCircle
              color={props.selected ? GreyGrey70 : GreenGreen80}
            />
          </Badge>
        )}
      </GridItem>
    </Grid>
  )
}
